import _ from 'lodash';
import ValidationEngine from './ValidationEngine';

/**
 * create a validation engine from the inputInformation objects list; each input information may have validation types in it
 * arguments - variable length list of arrays of InputInformation objects
 * @return ValidationEngine
 */
export default function validationEngineFromInputInformationList() {
	const lists = Array.prototype.slice.call(arguments);
	const comboResults = _.reduce(lists, (finalResult, list) =>
		_.reduce(list, (result, inputInformation) => {
			result[inputInformation.field] = inputInformation.validationTypes;
			return result;
		}, finalResult)
	, {});
	return new ValidationEngine(comboResults);
};
